import { Injectable, EventEmitter } from '@angular/core'
import { Router } from '@angular/router'
import { PathNode, Task, Resource } from '@mprep/shared/data/models'

@Injectable()
export class NavigationServiceMock {

  private _toggleSibebarEmitter: EventEmitter<boolean>

  constructor() {
    this._toggleSibebarEmitter = new EventEmitter()
  }

  public navigateToResource(
    resource: Resource,
    currentPathPosition?: {currentPath: PathNode, currentUnit: PathNode, currentSection: PathNode, currentTask: Task}
  ) {}
  public navigateToDashboard() {}
  public navigateToWorkspace() {}
  public navigateToLastWorkspaceLocation() {}
  public get onToggleSidebar() {
    return this._toggleSibebarEmitter
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/navigation.service.mock.ts